import { render, staticRenderFns } from "./RoleIndex.vue?vue&type=template&id=43f08644&scoped=true&"
import script from "./RoleIndex.vue?vue&type=script&lang=js&"
export * from "./RoleIndex.vue?vue&type=script&lang=js&"
import style0 from "./RoleIndex.vue?vue&type=style&index=0&id=43f08644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f08644",
  null
  
)

export default component.exports